import React from 'react';
import { Link } from 'react-router-dom';
import { HOME } from '../routes/paths';
import './NotFound.css';

function NotFound() {
  return (
    <main className="not-found-page">
      <div className="not-found-card">
        <p className="not-found-code">404</p>
        <h1>Page not found</h1>
        <p className="not-found-description">
          This page may have moved or is no longer available. Check the link or head back home.
        </p>
        <Link className="not-found-home" to={HOME}>Back to home</Link>
      </div>
    </main>
  );
}

export default NotFound;
